import {Action} from '../const';

const getIndexesArray = (index: number, count: number, length: number): Array<number> => {
  const isEven: boolean = !Boolean(count % 2);
  const before: number = isEven ? (count / 2) - 1 : (count - 1) / 2;
  const after: number = isEven ? count / 2 : (count - 1) / 2;
  const beforeArray: Array<number> = [];
  let prevIndex: number = index;
  Array(before).fill(``).forEach(() => {
    let rawIndex = prevIndex - 1;
    if (rawIndex === -1) {
      rawIndex = length - 1;
    }
    beforeArray.unshift(rawIndex);
    prevIndex = rawIndex;
  });
  const afterArray: Array<number> = [];
  let nextIndex: number = index;
  Array(after).fill(``).forEach(() => {
    let rawIndex = nextIndex + 1;
    if (rawIndex > length - 1) {
      rawIndex = 0;
    }
    afterArray.push(rawIndex);
    nextIndex = rawIndex;
  });
  return [...beforeArray, index, ...afterArray];
};

const getElementsByIndexes = (indexes: Array<number>, array: Array<React.ReactNode>) => {
  return indexes.map((it) => array[it]);
};

interface Step {
  direction: Action;
  steps: number;
}

const getToLeftSteps = (startIndex: number, finishIndex: number, arrayLength: number): number => {

  let stepsRight: number = 0;
  let nextIndex: number = startIndex;

  while(nextIndex !== finishIndex) {
    stepsRight++;
    nextIndex++;
    if (nextIndex === arrayLength - 1 && nextIndex === finishIndex) {
      break;
    }
    if (nextIndex === arrayLength) {
      nextIndex = 0;
    }
  }

  return stepsRight;
};

const getToRightSteps = (startIndex: number, finishIndex: number, arrayLength: number): number => {

  let stepsLeft: number = 0;
  let nextIndex: number = startIndex;

  while(nextIndex !== finishIndex) {
    stepsLeft++;
    nextIndex--;
    if (nextIndex === -1) {
      nextIndex = arrayLength - 1;
    }
  }

  return stepsLeft;
};

const getMinStepsData = (startIndex: number, finishIndex: number, arrayLength: number): Step => {

  const throughRight: number = getToRightSteps(startIndex, finishIndex, arrayLength);
  const throughLeft: number = getToLeftSteps(startIndex, finishIndex, arrayLength);
  if (throughRight <= throughLeft) {
    return {
      direction: Action.TO_RIGHT,
      steps: throughRight,
    };
  }
  return {
    direction: Action.TO_LEFT,
    steps: throughLeft,
  };
};

const getStepsData = (startIndex: number, finishIndex: number, arrayLength: number) => {
  const extremeRightPosition: boolean = startIndex === (arrayLength - 1) && finishIndex === 0;
  const extremeLeftPosition: boolean = startIndex === 0 && finishIndex === (arrayLength - 1);
  switch (true) {
    case extremeRightPosition:
      return {
        direction: Action.TO_LEFT,
        steps: 1,
      };
    case extremeLeftPosition:
      return {
        direction: Action.TO_RIGHT,
        steps: 1,
      };
    case finishIndex > startIndex:
      return {
        direction: Action.TO_LEFT,
        steps: getToLeftSteps(startIndex, finishIndex, arrayLength)
      };
  }
  return {
    direction: Action.TO_RIGHT,
    steps: getToRightSteps(startIndex, finishIndex, arrayLength)
  };
};

export {getIndexesArray, getElementsByIndexes, getToRightSteps, getToLeftSteps, getStepsData, getMinStepsData};
